import script from "./ProjectImportG703Mapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectImportG703Mapper.vue?vue&type=script&setup=true&lang=js"

import "./ProjectImportG703Mapper.vue?vue&type=style&index=0&id=51587600&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51587600"]])

export default __exports__